import chassis1 from "../../Assets/gallery/chassis-unveiling23/20230209_171637.jpg";
import chassis2 from "../../Assets/gallery/chassis-unveiling23/20230209_172056.jpg";
import chassis3 from "../../Assets/gallery/chassis-unveiling23/20230209_175830.jpg";
import chassis4 from "../../Assets/gallery/chassis-unveiling23/20230209_180225.jpg";
import chassis5 from "../../Assets/gallery/chassis-unveiling23/20230209_180301.jpg";

const chassisUnveiling23 = [chassis1, chassis2, chassis3, chassis4, chassis5];

export default chassisUnveiling23;
